import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#2D27F6'}
      d="M20.65.119 1 7.239c-.26.1-.44.33-.47.61-.03.28.11.54.36.68l6.13 3.5c.25.13.55.11.77-.06l7.91-5.98-5.98 7.91c-.17.22-.19.52-.06.77l3.49 6.13c.14.24.4.38.68.36.28-.02.52-.21.61-.47l7.12-19.65c.1-.26.03-.55-.17-.75a.712.712 0 0 0-.75-.17h.01Z"
    />
  </Svg>
);
export default SvgComponent;
